import { createContext } from 'react'

const ToastContext = createContext({ toast: [], setToast: toast => { } });
export default ToastContext